import { useQuery } from '@tanstack/react-query';

import useApi from '@/hooks/useApi/useApi';
import { queryKeys } from '@/lib/queryKeys';
import { CompanyAccountCategory } from '@/types/types';
import { API_URL } from '@/lib/apiUrl';

export const useCompanyAccountCategory = (id: string | number) => {
  const { axiosInstance } = useApi();

  return useQuery<CompanyAccountCategory>({
    queryKey: queryKeys.companyAccountCategories.detail(id).queryKey,
    queryFn: async () => {
      const { data } = await axiosInstance.get<CompanyAccountCategory>(
        `${API_URL}/api/v1/company_account_categories/${id}`
      );
      return data;
    },
    enabled: !!id,
  });
};

export default useCompanyAccountCategory;
